<template>
  <div class="fullheight">
    <eco-table @load="loadData" :data="data" :pageResult="pageResult" :selection="true" :show-export="false" ref="ecoTable">
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" @click="showDialog()" type="primary">添加</el-button>
          <fe-delete-button url="${third}/third_document_template/" :htTable="$refs.ecoTable" class="marginLeft16">删除</fe-delete-button>
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="name" label="凭证类型" :filters="documentEnumDataFilters">
          <template v-slot="{ row }">
            <el-tag v-show="row.name == s.id" v-for="s in documentEnumData" :key="s.id">{{ s.desc }}</el-tag>
          </template>
        </eco-table-column>

        <eco-table-column prop="createByName" label="编制人" :sortable="true" />
        <eco-table-column prop="createTime" label="编制日期" :sortable="true" :sort-by="'create_time_'" />
        <eco-table-column width="150" label="操作">
          <template v-slot="{ row }">
            <el-link type="primary" :underline="false" @click="showDialog(row.id, row.name)">编辑</el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>

    <el-dialog :close-on-click-modal="false" width="70%" :visible="dialogVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">凭证模版</span>
      </div>
      <div class="content">
        <el-form v-model="model" data-vv-scope="editModelForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <eco-form-item label="凭证类型">
                <eco-select
                  v-model="model.name"
                  :options="documentEnumData"
                  :props="{ key: 'id', value: 'desc' }"
                  :validate="{ required: true }"
                  placeholder="请输入凭证类型"
                  clearable
                  filterable
                  :disabled="documentEnumDisabled"
                  @change="changeDocumentEnum"
                  @clear="clearDocumentEnum"
                />
              </eco-form-item>
            </el-col>
            <el-col :span="12" v-if="tax_no != 'k3'">
              <eco-form-item label="凭证字号">
                <eco-select
                  v-model="model.wordSizeId"
                  :options="voucherGroup"
                  :props="{ key: 'id', value: 'name' }"
                  :validate="{ required: true }"
                  placeholder="请输入凭证字号"
                  clearable
                  filterable
                  @change="handleChange"
                  @clear="clearVoucher"
                />
              </eco-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <SysNcTemplateTableDefault
                :boKey="boKey"
                :modelName="model"
                :amountFieldList="amountFieldList"
                :financeTypeGroupList="financeTypeGroupList"
                :tableData="model.sub_third_document_template_detail"
                :dataSourceList="dataSourceList"
                :costList="costList"
                :taxNo="tax_no"
                @dataChange="templateTableData"
              ></SysNcTemplateTableDefault>
            </el-col>
          </el-row>
          <el-row style="height: 4rem; margin-top: 10px">
            <el-col :span="12">
              <eco-form-item label="编制人">
                <eco-input v-model="model.createByName" autocomplete="off" :validate="{ required: true }" disabled></eco-input>
              </eco-form-item>
            </el-col>
            <el-col :span="12">
              <eco-form-item label="编制时间">
                <el-date-picker class="el-input-date" v-model="model.createTime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:SS" disabled> </el-date-picker>
              </eco-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          :url="accountUrl"
          context="third"
          :model="model"
          :requestMethod="requestMethod"
          scope-name="editModelForm"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
        <el-button @click="handleClose()">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import req from '@/request.js'
import portalApi from '@/api/portal.js'
import utils from '@/utils.js'
import { Message } from 'element-ui'
const SysNcTemplateTableDefault = () => import('@/views/system/sysExternalUnite/SysNcTemplateTableDefault.vue')
export default {
  components: {
    SysNcTemplateTableDefault
  },
  computed: {},
  data() {
    return {
      amountFieldList: [],
      financeTypeGroupList: [],
      requestMethod: 'POST',
      accountUrl: '/third_document_template/save',
      dialogVisible: false,
      model: {},
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      documentEnumData: [],
      documentEnumDataFilters: [],
      documentEnumDisabled: false,
      boKey: '',
      dataSourceList: [],
      costList: [],
      tax_no: '',
      tenantId: '',
      voucherGroup: []
    }
  },
  mounted() {
    this.$validator = this.$root.$validator
  },
  created() {
    req.get('${third}/third_document_template/getDocumentEnumMap').then((response) => {
      this.documentEnumData = response.data

      response.data.forEach((item) => {
        const filtersData = {
          text: item.desc,
          value: item.id,
          type: 'success'
        }
        this.documentEnumDataFilters.push(filtersData)
      })
    })
    req.get('${third}/third_document_template/getDataSourceEnumMap').then((response) => {
      this.dataSourceList = response.data
    })
    portalApi.getCostAccountById().then((response) => {
      this.costList = response
    })
    this.getAccountModuleType()
    this.getVoucherGroup()
  },
  methods: {
    getVoucherGroup() {
      this.$http.get('${third}/voucher_group/getById?id=0').then((res) => {
        this.voucherGroup = res.data.length > 0 ? res.data : []
      })
    },
    // 通过模块控制映射按钮权限
    getAccountModuleType() {
      let tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
      this.tenantId = tenantId
      if (tenantId) {
        this.$http.get('${third}/system/account_mangement/getByTenantIdAndModule?id=' + `${tenantId}&accountModule=6`).then((res) => {
          if (res && res.data) {
            this.tax_no = res.data.tax_no
          }
        })
      }
    },
    handleClose() {
      ;(this.dialogVisible = false), (this.boKey = '')
      this.model = {}
    },
    afterSaveData() {
      this.dialogVisible = false
      this.$refs.ecoTable.load()
    },
    beforeSaveData() {
      if (this.model.sub_third_document_template_detail) {
        this.model.sub_third_document_template_detail.forEach((item) => {
          if (item.scopeOfAccounting) {
            item.scopeOfAccounting = item.scopeOfAccounting.join(',')
          }
        })
      }
    },
    showDialog(id, name) {
      req.get('${third}/third_document_template/getFinanceMappingTypeMap?type=' + name).then((response) => {
        this.financeTypeGroupList = response.data
      })
      if (id) {
        let haveAmountField = 0
        this.dialogVisible = false
        this.documentEnumDisabled = true
        req.get('${third}/third_document_template/getById?id=' + id).then((response) => {
          this.model = response.data
          this.model.sub_third_document_template_detail.forEach(function (item) {
            if (item.scopeOfAccounting) {
              item.scopeOfAccounting = item.scopeOfAccounting.split(',')
            }
          })
          this.boKey = response.data.boKey
        })
        if (name) {
          req.get('${third}/third_document_template/getAmountFieldByType?type=' + name).then((response) => {
            this.amountFieldList = response.data
            setTimeout(() => {
              this.dialogVisible = true
            }, 500)
            haveAmountField = 1
          })
        }
        setTimeout(() => {
          this.$validator.validateAll('editModelForm')
        }, 500)
      } else {
        this.documentEnumDisabled = false
        this.boKey = ''
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          createByName: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
        this.dialogVisible = true
      }
    },
    loadData(param, cb) {
      portalApi
        .getSysNcTemplate(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    changeDocumentEnum(data, selectObj) {
      this.boKey = selectObj.model
      this.model.sub_third_document_template_detail = []
    },
    clearDocumentEnum() {
      this.boKey = ''
    },
    templateTableData(tableData) {
      this.model.sub_third_document_template_detail = tableData
    },
    handleChange(data, selectObj) {
      this.model.wordSize = selectObj.name
    },
    clearVoucher() {
      this.model.wordSize = ''
      this.model.wordSizeId = ''
    }
  }
}
</script>
<style scoped>
div[aria-invalid='true'] >>> .el-input__inner,
div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
.input-with-select {
  width: 245px;
}
.el-input-date {
  width: 200px;
}
>>> .import_row {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
